/**
 * Find scrollable parent of element.
 */
import {
  getParentNode,
  getWindow,
  isElement,
  isRoot,
  hasOverflow
} from "../utils"

// TS complains if we don't explicitly annotate the return type
const getScrollParent_ = (node: Node): HTMLElement => {
  if (isRoot(node)) {
    return node.ownerDocument?.body ?? getWindow(node).document.body
  }

  return isElement(node) && hasOverflow(node)
    ? node
    : getScrollParent_(getParentNode(node))
}

// FIXME: This is necesary when testing the OCI DNS plugin dropdown in a legacy
// oui-react modal. Why? :shrug Could be a bug w/ TS, Babel or our JS minifier.
// It could also be a bug w/ Webpack or other build-chain tools in the plugin.
const getScrollParent = (node: Node) => getScrollParent_(node)

export default getScrollParent
